import { VatTypeEnum } from "../enums/VatTypeEnum";

export type VatAmountsType = {
  vatAmount: number;
  amountWithVat: number;
  amount: number;
};

const getVatRate = (vatType: VatTypeEnum): number => {
  switch (vatType) {
    case VatTypeEnum.Vat0:
      return 0;
    case VatTypeEnum.VatNo:
      return 0;
    case VatTypeEnum.Vat18:
      return 18;
  }

  return 0;
};

const getVatAmount = (vatType: VatTypeEnum, amount: number, priceIncludesVat: boolean): number => {
  const varRate = getVatRate(vatType);

  let vatAmount = 0;
  if (priceIncludesVat) {
    vatAmount = amount - amount / ((100 + varRate) / 100);
  } else {
    vatAmount = (amount * varRate) / 100;
  }

  return vatAmount;
}; // const handleValueChange = (value: any, index: number) => {
//   const newProducts = [...watchProducts];
//   let vatRate = newProducts[index].vatRate;
//   if (value === 2) {
//     vatRate = 18;
//   } else {
//     vatRate = 0;
//   }
//   console.log(value);
//   setValue(`products.${index}.vatRate`, vatRate);
// };
const getNewAmountsAfterQuantityPriceChanged = (newQuantity: number, newPrice: number, vatType: VatTypeEnum, priceIncludesVat: boolean): VatAmountsType => {
  const newAmount = newQuantity * newPrice;
  const newVatAmount = getVatAmount(vatType, newAmount, priceIncludesVat);
  const newAmountWithVat = priceIncludesVat ? newAmount : newAmount + newVatAmount;

  console.log(newVatAmount)
  return {
    vatAmount: newVatAmount,
    amount: newAmount,
    amountWithVat: newAmountWithVat
  };
};

export const AmountHelper = {
  getVatAmount,
  getVatRate,
  getNewAmountsAfterQuantityPriceChanged
};
